module.exports = __webpack_public_path__ + "static/media/beam-logo.47d08ab6.svg";